import React from "react";
import { Input, Row, Typography, Form, Col, Divider } from "antd";
import { labelConfig } from "../../../product.config";
const { Title } = Typography;

const DetailForm = (props) => {
  const { onFinish, form, formData } = props;
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.generalInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.productName}
            name="name"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Product Name"></Input>
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.shortName}
            name="shortName"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Short Name"></Input>
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.description}
            name="description"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input.TextArea></Input.TextArea>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DetailForm;
